import { render, staticRenderFns } from "./taskToDelay.vue?vue&type=template&id=c522b522&scoped=true&"
import script from "./taskToDelay.vue?vue&type=script&lang=js&"
export * from "./taskToDelay.vue?vue&type=script&lang=js&"
import style0 from "./taskToDelay.vue?vue&type=style&index=0&id=c522b522&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c522b522",
  null
  
)

export default component.exports